export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  const videoButton = `
  <a class="main-feature-button main-feature-video" href="#first-content">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M207.4 265.3c9.313 8.875 23.88 8.875 33.19 0l184-176c9.563-9.156 9.906-24.34 .75-33.94C420.6 50.47 414.3 48 408 48c-5.969 0-11.94 2.219-16.59 6.656L224 214.8L56.59 54.66C46.1 45.53 31.81 45.81 22.65 55.41S13.84 80.19 23.4 89.34L207.4 265.3zM408 240c-5.969 0-11.94 2.219-16.59 6.656L224 406.8L56.59 246.7C46.1 237.5 31.81 237.8 22.65 247.4S13.84 272.2 23.4 281.3l184 176c9.313 8.875 23.88 8.875 33.19 0l184-176c9.563-9.156 9.906-24.34 .75-33.94C420.6 242.5 414.3 240 408 240z"/></svg>
  <p>Learn more</p>
  </a>
  <div class="main-feature-content">
  <h1>Welcome To Club 19</h1>
  <p>The perfect venue for the perfect event!</p>
  <div class="button">
  <a href="#first-content">Learn More</a>
  </div>
  </div>
  `

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${'videoSection'}`).append(videoButton);



  $(`#${widgetName}`).videoWidget({

    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
    , detectIpad: IPADDETECTED
    // options
    , multiVideo: false
    , showOnMobile: true
    , maxVideos: 1
    , autoPlayVideo: true
    , trackingGA: {
      present: false,
      event: 'event',
      gaObj: {
        eventCategory: 'Videos',
        eventAction: '',
        eventLabel: '',
      }
    }
    , videoWidgetLoaded: function () {

   

    }
  });

};
